import { BasicComments } from "component/comment";
import { CLICK, componentWithVariants, demoFile, INPUT, story, variant } from "system/demo";

demoFile('feature/comments/reply-notifs');

const collections = {comment: [
    {key: 1, from: 'b', text: 'This is a comment'},
]}

componentWithVariants('BasicComments', BasicComments, {}, [
    variant('With Reply Notifications', {
        structureKey: 'simplecomments',
        features: ['replynotifications'],
        state: {collections}
    }, [
        story('Reply to comment', [
            CLICK('Reply'),
            INPUT('comment-edit', 'Replying to the comment'),
            CLICK('Post')
        ])
    ])
])
